import React, { useState, memo } from "react";
import Image from "next/image";

const CustomImage = ({
  field,
  handleMouesHoverOnImage,
  activeStyles,
  extractedSrc,
  handleClick,
  imageAlt,
  imagePriority,
  imageFetchPriority

}: {
  field: any;
  handleMouesHoverOnImage: Function;
  extractedSrc: string;
  activeStyles: any;
  handleClick?: Function;
  imageAlt: string;
  imagePriority: boolean;
  imageFetchPriority: "auto" | "high" | "low" | undefined;
}) => {
  const [showMagnifier, setShowMagnifier] = useState(false);
  const [magnifierImagePosition, setMagnifierImagePosition] = useState({
    x: 0,
    y: 0,
  });
  return (
    <>
      {(field?.fieldType === "link" && field?.prefix) ?? ""}
      <Image
        id={field?.id ?? ""}
        alt={imageAlt}
        {...(field.imageHover
          ? {
              onMouseEnter: () => setShowMagnifier(true),
              onMouseLeave: () => setShowMagnifier(false),
            }
          : {})}
        src={extractedSrc}
        className={field?.imageClassName ?? ""}
        aria-label={extractedSrc}
        height={parseFloat(
          field?.imageStyle?.height
            ? field?.imageStyle?.height.toString()
            : field?.style?.height
            ? field?.style?.height?.toString()
            : "0"
        )}
        width={parseFloat(
          field?.imageStyle?.width
            ? field?.imageStyle?.width?.toString()
            : field?.style?.width
            ? field?.style?.width?.toString()
            : "0"
        )}
        onError={(e: any) =>
          (e.target.src = `${
            process.env.NEXT_PUBLIC_IMAGE_BASE_URL ||
            "https://d1s24u4ln0wd0i.cloudfront.net/website/new_ecom_asset"
          }/product.webp`)
        }
        style={{
          position: field?.imageHover ? "relative" : "static",
          borderRadius: field?.style?.borderRadius ?? "0",
          ...field?.style,
          ...activeStyles,
        }}
        onClick={(e) => (handleClick ? handleClick(e) : () => {})}
        onMouseMove={(e) => {
          if (field?.imageHover) {
            if (!showMagnifier) {
              setShowMagnifier(true);
            }
            handleMouesHoverOnImage(e, setMagnifierImagePosition);
          }
        }}
        priority={imagePriority}
        unoptimized={
          field?.unoptimized !== undefined ? field.unoptimized : true
        }
        loading={!imagePriority ? "lazy" : "eager"}
        fetchPriority={imageFetchPriority}
      />
      {showMagnifier && (
        <div
          className="image-magnifier-position-teller"
          style={{
            top: `${magnifierImagePosition.y}%`,
            left: `${magnifierImagePosition.x}%`,
            transform: "translate(-50%,-50%)",
            pointerEvents: "none",
            position: "absolute",
            height: "100px",
            width: "100px",
            borderRadius: "4px",
            backgroundColor: "rgba(25, 87, 164, 0.6)",
          }}
        ></div>
      )}
      {extractedSrc && showMagnifier && (
        <div
          className="image-magnifier"
          style={{
            backgroundImage: `url(${encodeURI(extractedSrc).replace(/'/g, '%27')})`,
            backgroundPosition: `${magnifierImagePosition?.x}% ${magnifierImagePosition?.y}%`,
            border: "2px solid rgba(25, 87, 164, 1)",
            position: "absolute",
            top: "0",
            left: "105%",
            height: "60vh",
            width: "558px",
            zIndex: "9999",
            backgroundRepeat: "no-repeat",
            backgroundColor: "white",
            backgroundSize: "200%",
            boxShadow: "0px 0px 50px 0px rgba(0, 0, 0, 0.31)",
            borderRadius: "8px",
          }}
        ></div>
      )}
    </>
  );
};

export default memo(CustomImage);
